<template>
  <div
    class="dropdown dropdown v-select single searchable custom-select"
    :class="[isShowOptions ? 'open' : '', form_type]"
    v-on-clickaway="handleClickAway"
  >
    <div :class="['dropdown-toggle', { 'disabled--field': disabled }]">
      <div class="vs__selected-options selected-options" @click="showOptions">
        <input
          type="search"
          class="form-control"
          :disabled="disabled"
          :placeholder="placeholder"
          v-model="search"
          @input="typing()"
          v-if="searchable == true"
        />
        <span v-else>
          <template v-if="search == ''">
            {{ placeholder }}
          </template>
          {{ search }}
        </span>
      </div>
      <div class="vs__actions">
        <i
          role="presentation"
          class="open-indicator"
          @click="showOptions()"
          v-if="!isLoading"
        ></i>
        <Spinner class="spinner" v-else :theme="primary" />
      </div>
    </div>
    <ul
      role="listbox"
      class="options dropdown-menu"
      v-scroll="handleScroll"
      v-if="isShowOptions"
      ref="options"
      :style="{
        'max-height': height
      }"
    >
      <template>
        <li
          v-for="(item, key) in options"
          :key="key"
          role="option"
          class="active"
        >
          <a @click="handleSelect(item)"> {{ item.label }} </a>
        </li>
      </template>
      <li class="active" v-if="isLoading">
        Loading...
      </li>
      <li v-else-if="options.length <= 0" class="active">
        {{ noOptions }}
      </li>
    </ul>
  </div>
</template>
<script>
import Spinner from "@/components/Spinner";
import _ from "lodash";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "CustomSelect",
  props: {
    options: {
      type: [Array, Object],
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    searchable: {
      type: [String, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    noOptions: {
      type: String,
      default: "No data found"
    },
    value: {
      type: [String, Object],
      default: null
    },
    config: {
      type: Object,
      default: null
    },
    form_type: {
      type: String,
      default: ""
    }
  },
  components: {
    Spinner
  },
  mixins: [clickaway],
  data() {
    return {
      isShowOptions: false,
      search: "",
      selectedValue: {},
      height: "",
      width: ""
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  created() {
    if (this.value && this.value.label !== undefined && this.value.label) {
      this.search = this.value.label;
    }
  },
  mounted() {
    if (this.config && this.config.displaySize) {
      this.height =
        this.config.displaySize * 40 -
        this.config.displaySize * 3 +
        "px !important";
    }
  },
  watch: {
    value: function(val) {
      if (!val) {
        this.search = "";
      }
    }
  },
  methods: {
    handleScroll(el, position) {
      const divScrollHeight = Math.floor(el.target.scrollHeight);
      const scrollCurrentHeight = Math.floor(
        position.scrollTop + el.target.offsetHeight
      );
      if (divScrollHeight === scrollCurrentHeight && this.isLoading === false) {
        this.$emit("handleOptions", { search: this.search });
      }
    },
    typing() {
      this.isShowOptions = true;
      this.$emit("typing");
      this.$emit("handleOptions", { search: this.search });
    },
    showOptions() {
      if (this.disabled) return;
      this.isShowOptions = !this.isShowOptions;
    },
    handleSelect({ label }) {
      if (this.disabled) return;
      let options = this.options;
      let selectedValue = _.find(options, { label: label });
      this.$emit("input", selectedValue);
      this.search = selectedValue.label;
      this.isShowOptions = false;
    },
    handleClickAway() {
      this.isShowOptions = false;
      if (this.value && this.searchable) {
        this.search = this.value.label;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-select {
  width: 100%;
  &.open .form-type,
  &.form_type {
    &.default .selected-options {
      line-height: 2.4;
    }
    & .dropdown-toggle {
      border: 1px solid #e8e8e8 !important;
      .selected-options {
        padding-top: 0;
        padding-bottom: 0;
        height: 34px;
        & input,
        span {
          font-family: "Gotham Book", sans-serif !important;
          font-size: 0.75rem;
        }
      }
      &.disabled--field {
        background: #f3f3f3;
      }
    }
  }
  & .dropdown-toggle {
    border: 1px solid var(--primary, currentColor);
    border-radius: 6px;
    height: 100%;
    padding: 0;
    line-height: 2;
    .selected-options {
      cursor: pointer;
      & input,
      span {
        margin: 0;
        padding: 0.1875rem 0.25rem;
        line-height: 2.4;
      }
    }
    .spinner {
      align-items: center;
    }
  }
  & .options {
    max-height: 400px;
    transition: all 0.3s ease-in;
    & > li {
      a {
        background-color: #fff;
      }
      :hover {
        background-color: rgb(207, 207, 207);
      }
    }
  }
}
</style>
